module.exports = __webpack_public_path__ + "img/4.c396a05a.jpg";